import React, {FC, useContext, useMemo} from 'react'
import {Accordion, AccordionContext, Card, useAccordionButton} from 'react-bootstrap'
import unescape from 'lodash/unescape'
import ComponentButton from '../../../components/ComponentButton'
import ComponentCheckbox from '../../../components/ComponentCheckbox'
import {AccordionView} from '../../ModuleAccordion'

type Props = {
    id: number
    title: string
    body?: string | null
    status: {value?: string; title?: string}
    signedAt?: string | null
    redirect_page: string
    checked: boolean
    onToggle: () => void
    href?: {path: string; extension: string} | null
}

const SignAccordionItem: FC<Props> = ({
    id,
    title,
    body,
    status,
    signedAt,
    redirect_page,
    checked,
    onToggle,
    href,
}) => {
    const eventKey = String(id)
    const {activeEventKey} = useContext(AccordionContext)
    const isOpen = activeEventKey === eventKey

    const toggleAccordion = useAccordionButton(eventKey)

    const view = useMemo(() => {
        if (body) {
            return 'native'
        } else if (href) {
            switch (href.extension) {
                case 'pdf':
                    return href.extension
                case 'jpg':
                case 'jpeg':
                case 'png':
                case 'webp':
                case 'svg':
                    return 'image'
            }
        }
        return 'link'
    }, [body, href])

    return (
        <Card className='signAccordion_item'>
            <Card.Header
                className={`signAccordion_header ${isOpen ? 'active' : ''}`}
                onClick={toggleAccordion}
            >
                <div className='signAccordion_headerLeft'>
                    <ComponentCheckbox customChecked={checked} customHandler={onToggle} />
                </div>

                <div className='signAccordion_meta'>
                    <span className={`signAccordion_status status_${status?.value}`}>
                        {status?.title || status?.value || '—'}
                    </span>

                    {signedAt ? <span className='signAccordion_date'>{signedAt}</span> : null}

                    <div className='signAccordion_title'>{title}</div>
                </div>

                <ComponentButton
                    type='href'
                    settings={{
                        title: 'Подписать',
                        background: 'dark',
                        icon: 'check',
                        page: `${redirect_page}?id=${id}`,
                    }}
                />
            </Card.Header>

            <Accordion.Collapse eventKey={eventKey}>
                <Card.Body className='moduleAccordion_itemBody'>
                    <React.Suspense fallback={<div>Загрузка...</div>}>
                        <AccordionView
                            view={view}
                            body={body ? unescape(body) : undefined}
                            href={href?.path}
                        />
                    </React.Suspense>
                </Card.Body>
            </Accordion.Collapse>
        </Card>
    )
}

export default SignAccordionItem
